module.exports = __webpack_public_path__ + "img/titleCustomized.dfa844e2.png";